import React from 'react';
import { Outlet } from 'react-router-dom';
import VendeurHeader from '../composants/VendeurHeader'
import VendeurFooter from '../pages/VendeurFooter';

function VendeurLayout() {
  return (
    <>
      <div className="vendeur-layout">
      <VendeurHeader />
      <main style={{ minHeight: 'calc(100vh - 200px)' }}>
        <Outlet />
      </main>
      <VendeurFooter />
    </div>
    </>
  );
}

export default VendeurLayout;
